import * as React from 'react';
import { useSelector } from 'react-redux';

import { BuildersAgents } from '../../components/BuildersAgents';
import { getAdditionalBuilders, getSellers } from '../../selectors/newbuilding';

export function BuildersAgentsContainer() {
  const builders = useSelector(getAdditionalBuilders);
  const sellers = useSelector(getSellers);

  if (builders.length === 0 && sellers.length === 0) {
    return null;
  }

  return <BuildersAgents builders={builders} sellers={sellers} />;
}
